import { render, staticRenderFns } from "./SubmitSnackbar.vue?vue&type=template&id=68c70764&scoped=true&"
import script from "./SubmitSnackbar.vue?vue&type=script&lang=js&"
export * from "./SubmitSnackbar.vue?vue&type=script&lang=js&"
import style0 from "./SubmitSnackbar.vue?vue&type=style&index=0&id=68c70764&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c70764",
  null
  
)

export default component.exports